<script>
  import "jquery-nice-select";
  import { onMount } from "svelte";

  export let label = "";
  export let fieldName = "";
  export let value = "";
  export let required = false;
  export let selectOptions = [];
  export let labelField = "text";
  export let valueField = "value";
  export let placeholder = "Lütfen Seçiniz";
  export let onChange = null;

  const inputID = Math.random().toString(36).slice(2, 12);

  onMount(() => {
    window.jQuery(`#${inputID}`).niceSelect();
    if (typeof onChange === 'function') {
      window.jQuery(`#${inputID}`).on('change', function(ev){
        onChange(window.jQuery(this).val())
      });
    }
  });

  $: {
    if (typeof value !== 'string' && value?.toString) {
      value = value.toString();
    }
    setTimeout(() => { // TODO :: Nice select doesnt render's default value
      window.jQuery(`#${inputID}`).niceSelect('update');
    }, 0);
  }

  const onKeyPress = (e) => {
    // TODO: need to look for buggy choose
    console.log(e);
  }
</script>

{#if label}
  <label class="form-label" for={inputID}>
    {label}
    {#if required}
      <span class="text-red">*</span>
    {/if}
  </label>
{/if}
<select
  class="default-select form-control wide"
  name={fieldName}
  on:keypress={onKeyPress}
  id={inputID}
  {required}
  bind:value
>
  {#if placeholder}
    <option value="" disabled>{placeholder}</option>
  {/if}
  {#each selectOptions as selectOption}
    <option value={selectOption[valueField]}>{selectOption[labelField]}</option>
  {/each}
</select>
